import * as Hapi from 'hapi'
import { Injector } from 'reduct'
import Version from '../services/Version'

export default function (server: Hapi.Server, deps: Injector) {
  const ver = deps(Version)

  async function getVersion (request: Hapi.Request, h: Hapi.ResponseToolkit) {
    return {
      name: ver.getImplementationName(),
      version: ver.getVersion()
    }
  }

  server.route({
    method: 'GET',
    path: '/version',
    handler: getVersion
  })
}
